import React from "react";
import { Lightning } from "@phosphor-icons/react";

/**
 * Tradelog brand mark — bolt icon + wordmark. Used on the prop-challenge
 * dashboard header and the shared P&L / certificate share card so the
 * screenshotted card is instantly identifiable as Tradelog.
 */
export function BrandLogo({ size = 22, wordmark = true, tone = "primary", className = "" }) {
  const boltCls = tone === "white" ? "text-white" : "text-primary";
  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="brand-logo">
      <div
        className="grid place-items-center rounded-md"
        style={{
          width: size * 1.15, height: size * 1.15,
          background: tone === "white"
            ? "rgba(255,255,255,0.10)"
            : "linear-gradient(135deg, hsl(var(--primary)/0.25), hsl(var(--primary)/0.05))",
          border: tone === "white"
            ? "1px solid rgba(255,255,255,0.25)"
            : "1px solid hsl(var(--primary)/0.35)",
        }}>
        <Lightning size={size * 0.7} weight="fill" className={boltCls} />
      </div>
      {wordmark && (
        <span
          className="font-display font-bold tracking-tight leading-none"
          style={{ fontSize: size * 0.9 }}>
          Tradelog
        </span>
      )}
    </div>
  );
}

export default BrandLogo;
